export default __webpack_public_path__ + "static/media/features.62768d4a.png";